// The root route's error boundary: what Next.js did with redirect(),
// notFound() and app/global-error.tsx, in one place.

import { useEffect } from "react";
import { Navigate, useRouteError } from "react-router";

import GlobalError from "@/app/global-error";
import NotFound from "@/app/not-found";
import { isHardHref } from "@/nav/hrefs";
import { NotFoundSignal, RedirectSignal } from "@/nav/navigation";

function HardRedirect({ href }: { href: string }) {
  useEffect(() => {
    window.location.replace(href);
  }, [href]);
  return null;
}

export function RouteErrorBoundary() {
  const error = useRouteError();
  if (error instanceof RedirectSignal) {
    return isHardHref(error.href) ? <HardRedirect href={error.href} /> : <Navigate to={error.href} replace />;
  }
  if (error instanceof NotFoundSignal) return <NotFound />;
  const err = error instanceof Error ? error : new Error(String(error));
  // reset() re-rendered the segment in Next; a reload is the SPA's equivalent.
  return <GlobalError error={err} reset={() => window.location.reload()} />;
}
